/* Auto-generated 2026-10-29 03:00:05 by rr_sync_products.py — do not edit by hand */
var COLLECTIONS = [
  {id:"best-sellers",name:"Best Sellers",img:"https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_8c5ce54a-9630-4180-97f3-429c45c04e5a.jpg?v=1781301840?width=800",desc:"Our most-loved pieces.",count:68},
  {id:"feminist",name:"Feminist",img:"https://cdn.shopify.com/s/files/1/0757/4362/5453/files/84601c89d7dbf5d4769d4e770ff8102f.jpg?v=1754401581?width=800",desc:"For the matriarchy.",count:2},
  {id:"protest",name:"Protest",img:"https://cdn.shopify.com/s/files/1/0757/4362/5453/files/mens-fitted-t-shirt-black-front-6892324e708a6.jpg?v=1754411608?width=800",desc:"Dissent as a design practice.",count:20},
  {id:"lgbtq-pride",name:"LGBTQ+ Pride",img:"https://cdn.shopify.com/s/files/1/0757/4362/5453/files/028eee329065967ba6c90a9a438f7551.jpg?v=1754401701?width=800",desc:"Loud, proud, and printed.",count:2},
  {id:"funny-and-political",name:"Funny & Political",img:"https://cdn.shopify.com/s/files/1/0757/4362/5453/files/35cea5fdba0124fd8184f5c2e997fe6f.jpg?v=1754401792?width=800",desc:"Because satire is resistance.",count:11},
  {id:"womens-tees",name:"Women's Tees",img:"https://cdn.shopify.com/s/files/1/0757/4362/5453/files/33879facc920211350ecf6fa90b5d9ea.jpg?v=1754401824?width=800",desc:"Fitted for the fight.",count:19},
  {id:"unisex-tees",name:"Unisex Tees",img:"",desc:"For every body in the movement.",count:0},
  {id:"hoodies",name:"Hoodies",img:"https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_8c5ce54a-9630-4180-97f3-429c45c04e5a.jpg?v=1781301840?width=800",desc:"Stay warm, stay woke.",count:12},
  {id:"accessories",name:"Accessories",img:"https://cdn.shopify.com/s/files/1/0757/4362/5453/files/977ba94c652c135512ca9b428c9a9a19.jpg?v=1754401842?width=800",desc:"Mugs, hats and more.",count:2},
  {id:"new-arrivals",name:"New Arrivals",img:"https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_8c5ce54a-9630-4180-97f3-429c45c04e5a.jpg?v=1781301840?width=800",desc:"Just dropped.",count:68}
];
var PRODUCTS = [
  {
    id: "eat-the-rich-unisex-hoodie-rebels-rights",
    name: "Eat the Rich",
    type: "Hoodie",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "hoodies",
    slogan: "Eat the Rich",
    price: 32.95,
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: ["Black", "Navy", "Maroon", "Charcoal", "Dark Chocolate"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_8c5ce54a-9630-4180-97f3-429c45c04e5a.jpg?v=1781301840?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-2_018acab5-7614-4253-acda-511e168f22de.jpg?v=1781301845?width=900",
    desc: "When three people own more than the bottom half of the planet combined, something's gone very wrong \u2014 and polite conversation isn't fixing it. For the economic justice fighters, the union members, and everyone who's working two jobs and still behind. Soft unisex fit, pre-shrunk,...",
    badge: "NEW",
  },
  {
    id: "no-kings-unisex-hoodie-rebels-rights",
    name: "No Kings",
    type: "Hoodie",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "hoodies",
    slogan: "No Kings",
    price: 32.95,
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: ["Black", "Dark Chocolate", "Forest Green", "Maroon", "Navy"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_5390db8a-4e13-4e64-80af-ebd205408a08.jpg?v=1781298036?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-2_92474a45-1d4e-4df5-ab9e-256a6adbe176.jpg?v=1781298045?width=900",
    desc: "Two words. Centuries of meaning. From Magna Carta to the present moment, the fight against unchecked power never really ends \u2014 it just changes costumes. For the constitutionalists, the democracy defenders, and anyone who knows what it looks like when one person grabs too much....",
    badge: "NEW",
  },
  {
    id: "well-behaved-women-rarely-make-history-unisex-hoodie-rebels-rights",
    name: "Well-Behaved Women Rarely Make History",
    type: "Hoodie",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "hoodies",
    slogan: "Well-Behaved Women Rarely Make History",
    price: 32.95,
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: ["Black", "Dark Chocolate", "Forest Green", "Maroon", "Navy"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_f8e6b45d-3eae-4a8e-a068-bc3b68063a96.jpg?v=1781297982?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-2_a52b806e-03c1-4d82-b451-2c359b32dc1c.jpg?v=1781297986?width=900",
    desc: "Every woman who changed the world had someone tell her to sit down and be quiet first. She didn't. This is for the rule-breakers, the loud ones, the ones who get called difficult and take it as a compliment. Soft, fitted Bella+Canvas 6004, runs true to size. Wear it like you...",
    badge: "NEW",
  },
  {
    id: "girls-just-want-to-have-fundamental-rights-unisex-hoodie-rebels-rights",
    name: "Girls Just Want to Have Fundamental Rights",
    type: "Hoodie",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "hoodies",
    slogan: "Girls Just Want to Have Fundamental Rights",
    price: 32.95,
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: ["Black", "Dark Chocolate", "Forest Green", "Maroon", "Navy"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_4e129172-df79-4c1a-8a24-10400566bc12.jpg?v=1781297861?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-2_edf38a88-01c7-4a61-bbc5-47b1a0703f0e.jpg?v=1781297865?width=900",
    desc: "We updated Cyndi's agenda slightly: the right to vote, to bodily autonomy, to equal pay, and to not be talked over in meetings. Wild requests, apparently. Soft, fitted Bella+Canvas 6004, runs true to size. Not asking \u2014 demanding.",
    badge: "NEW",
  },
  {
    id: "sounds-gay-im-in-unisex-hoodie-rebels-rights",
    name: "Sounds Gay, I'm In",
    type: "Hoodie",
    cause: "LGBTQ+",
    causeColor: "#7B4EA4",
    collection: "hoodies",
    slogan: "Sounds Gay, I'm In",
    price: 32.95,
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: ["White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_abb44fd6-60af-41b1-9444-e6ef22c04b58.jpg?v=1781297830?width=900",
    imgAlt: "",
    desc: "Enthusiastic consent. Every time. This pride staple is for the joyfully queer, the loudly allied, and anyone who says yes first and asks questions later \u2014 especially if glitter is involved. Wear it to Pride, to brunch, to literally anywhere you want to radiate pure celebratory...",
    badge: "NEW",
  },
  {
    id: "my-therapist-knows-about-you-unisex-hoodie-rebels-rights",
    name: "My Therapist Knows About You",
    type: "Hoodie",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "hoodies",
    slogan: "My Therapist Knows About You",
    price: 32.95,
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: ["Black", "Dark Chocolate", "Forest Green", "Maroon", "Navy"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_94b50a54-3bb2-48ca-b119-60d84146272b.jpg?v=1781297717?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-2_324f7ce6-faa0-4e4b-9163-efb5558479d7.jpg?v=1781297721?width=900",
    desc: "You've been discussed at length \u2014 and honestly, you earned it. This one's for everyone doing the work: processing, unpacking, and occasionally venting to a professional about That Person. Soft unisex fit, pre-shrunk, runs true to size on the Bella+Canvas 3001. Wear it proudly....",
    badge: "NEW",
  },
  {
    id: "deport-deez-nutz-unisex-hoodie-rebels-rights",
    name: "Deport Deez Nutz",
    type: "Hoodie",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "hoodies",
    slogan: "Deport Deez Nutz",
    price: 32.95,
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: ["Black", "Navy", "Charcoal", "Dark Chocolate", "Dark Heather"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_fe24496e-2054-4f1b-a849-bb968d9f82ac.jpg?v=1781297570?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-2_fd4e7124-b415-465f-b42c-8731b4036b31.jpg?v=1781297574?width=900",
    desc: "When the policies are that absurd, the response gets to match. Immigration fear-mongering deserves exactly this level of respect \u2014 which is to say, none. For the satirists, the smartasses, and the activists who know that laughter is also a weapon. Soft unisex fit, pre-shrunk,...",
    badge: "NEW",
  },
  {
    id: "when-tyranny-becomes-law-rebellion-becomes-duty-unisex-hoodie-rebels-rights",
    name: "When Tyranny Becomes Law, Rebellion Becomes Duty",
    type: "Hoodie",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "hoodies",
    slogan: "When Tyranny Becomes Law, Rebellion Becomes Duty",
    price: 32.95,
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: ["Black", "Charcoal", "Dark Chocolate", "Dark Heather", "Forest Green"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_ac92ae22-3e27-4a8b-996b-ab1c8d9e67ba.jpg?v=1781297669?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-2_9325a406-79cc-4a18-99b5-0eaddbdfc40e.jpg?v=1781297673?width=900",
    desc: "Some quotes don't age \u2014 they activate. When the rules serve the rulers and not the people, resistance isn't just justified, it's required. For the history-readers, the street-walkers, the ones who know exactly how we got here and refuse to go quietly. Soft unisex fit,...",
    badge: "NEW",
  },
  {
    id: "black-lives-matter-unisex-hoodie-rebels-rights",
    name: "Black Lives Matter",
    type: "Hoodie",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "hoodies",
    slogan: "Black Lives Matter",
    price: 32.95,
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: ["Black", "Charcoal", "Dark Chocolate", "Dark Heather", "Forest Green"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1.jpg?v=1781297532?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-2.jpg?v=1781297536?width=900",
    desc: "Not a slogan. A statement of fact that shouldn't require repeating \u2014 and yet. For the marchers, the mourners, the educators, and everyone who refuses to let the urgency fade between news cycles. This one doesn't negotiate. It affirms. Soft unisex fit, pre-shrunk, runs true to...",
    badge: "NEW",
  },
  {
    id: "veto-the-cheetoh-unisex-hoodie-rebels-rights",
    name: "Veto the Cheetoh",
    type: "Hoodie",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "hoodies",
    slogan: "Veto the Cheetoh",
    price: 32.95,
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: ["Black", "White", "Navy", "Ash", "Light Pink"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_09e4e2c5-40fd-4c77-aa0e-d531eb60b631.jpg?v=1781301889?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-2_cc767d3b-9936-4de9-b114-7fd4071ffdda.jpg?v=1781301893?width=900",
    desc: "Because sometimes the most serious thing you can do is laugh \u2014 loudly, in public, on a shirt. Political absurdity deserves absurdist commentary, and this one delivers. For the satirists, the sign-makers, and everyone who believes ridicule is a valid form of resistance. Soft...",
    badge: "NEW",
  },
  {
    id: "my-body-my-business-pullover-hoodie-rebels-rights",
    name: "My Body My Business",
    type: "Hoodie",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "hoodies",
    slogan: "My Body My Business",
    price: 32.95,
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: ["Black", "Charcoal", "Dark Chocolate", "Dark Heather", "Forest Green"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_fcdcb6a2-4cce-44a9-a152-d8a97698a3b9.jpg?v=1781302008?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-2_1f728945-de62-4507-99d2-17e1b25a5ca3.jpg?v=1781302012?width=900",
    desc: "Not a negotiation. Not a political platform. Not up for a vote. Your body belongs to you \u2014 full stop \u2014 and this shirt says so without apology. Soft, fitted Bella+Canvas 6004, runs true to size. Wear it loud, wear it proud.",
    badge: "NEW",
  },
  {
    id: "well-behaved-women-rarely-make-history-pullover-hoodie-rebels-rights",
    name: "Well-Behaved Women Rarely Make History",
    type: "Hoodie",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "hoodies",
    slogan: "Well-Behaved Women Rarely Make History",
    price: 32.95,
    sizes: ["S", "M", "L", "XL", "2XL"],
    colors: ["Black", "Dark Chocolate", "Forest Green", "Maroon", "Navy"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-1_af6886f3-e556-4d9a-a117-b1d088e045cb.jpg?v=1781302056?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/hoodie-2_1c4e1a3e-9ef5-4599-978b-e58573cae67f.jpg?v=1781302060?width=900",
    desc: "Every woman who changed the world had someone tell her to sit down and be quiet first. She didn't. This is for the rule-breakers, the loud ones, the ones who get called difficult and take it as a compliment. Soft, fitted Bella+Canvas 6004, runs true to size. Wear it like you...",
    badge: "NEW",
  },
  {
    id: "rebels-rights-fitted-tee",
    name: "Rebels & Rights Fitted Tee",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Rebels & Rights Fitted Tee",
    price: 26.95,
    sizes: ["XS", "S", "M", "L", "XL", "2X", "3X"],
    colors: ["Black", "Midnight Navy", "Royal Blue", "Heather Grey"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/mens-fitted-t-shirt-black-front-6892324e708a6.jpg?v=1754411608?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/mens-fitted-t-shirt-heather-grey-front-6892324e75b77.jpg?v=1754411609?width=900",
    desc: "The signature. Clean, confident, and cut for people who believe the personal is political \u2014 and dress accordingly. The Rebels &amp; Rights brand tee is the one you reach for when the message doesn't need to shout, it just needs to show up. Slim-fit Bella+Canvas construction \u2014...",
    badge: "NEW",
  },
  {
    id: "rebels-rights-utility-crossbody-bag",
    name: "Rebels & Rights Utility Crossbody Bag",
    type: "Accessories",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "accessories",
    slogan: "Rebels & Rights Utility Crossbody Bag",
    price: 31.95,
    sizes: [],
    colors: [],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/977ba94c652c135512ca9b428c9a9a19.jpg?v=1754401842?width=900",
    imgAlt: "",
    desc: "Carry your values with you \u2014 literally. This crossbody is built for people on the move: rallies, reading groups, market runs, whatever your version of showing up looks like. The Rebels &amp; Rights mark keeps you repped while you stay hands-free and ready. Durable canvas...",
    badge: "NEW",
  },
  {
    id: "rebels-rights-unisex-trucker-hat",
    name: "Rebels & Rights Unisex Trucker Hat",
    type: "Hat",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "accessories",
    slogan: "Rebels & Rights Unisex Trucker Hat",
    price: 23.95,
    sizes: [],
    colors: ["Black", "Navy", "Moss/ Khaki", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/992b0781498722c54aadd1dac50ee4f8.jpg?v=1754401834?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/bfa8f024249cb11e699ffbc543ee5278.jpg?v=1754401834?width=900",
    desc: "The movement needs a hat. This one's structured, sharp, and built for people who show up \u2014 at rallies, at the farmers market, at whatever comes next. The Rebels &amp; Rights wordmark sits front and center, no explanation needed. Six-panel structured cap with mesh back,...",
    badge: "NEW",
  },
  {
    id: "good-trouble-lives-on-quot-women-39-s-tee-rebels-rights",
    name: "Good Trouble Lives On&quot; Women&#39;s Tee",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "Good Trouble Lives On&quot; Women&#39;s Tee",
    price: 24.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Heather Prism Natural", "Citron", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/33879facc920211350ecf6fa90b5d9ea.jpg?v=1754401824?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/bbf355e8e85071992044585a1b0fb9c0.jpg?v=1754401824?width=900",
    desc: "John Lewis called it 'good trouble' \u2014 the necessary kind, the kind that bends the arc of justice. This one carries his legacy forward, worn by everyone who shows up, speaks out, and refuses to be silent when silence is complicity. Heavyweight, garment-dyed with a vintage feel...",
    badge: "NEW",
  },
  {
    id: "good-trouble-lives-on-unisex-tee-rebels-rights",
    name: "Good Trouble Lives On",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Good Trouble Lives On",
    price: 19.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Sport Grey", "Natural", "Ice Grey", "Ash", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/63b95f37e65415ebaf23630705a44167.jpg?v=1754401813?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/93054de6b2fa77f6b22154419fef6fad.jpg?v=1754401813?width=900",
    desc: "John Lewis called it 'good trouble' \u2014 the necessary kind, the kind that bends the arc of justice. This one carries his legacy forward, worn by everyone who shows up, speaks out, and refuses to be silent when silence is complicity. Heavyweight, garment-dyed with a vintage feel...",
    badge: "NEW",
  },
  {
    id: "caring-about-other-people-is-not-political-women-s-tee-rebels-rights",
    name: "Caring About Other People Is Not Political",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "Caring About Other People Is Not Political",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Dark Grey Heather", "Heather Prism Natural", "Citron", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/d0be7d67fcc1d8ceec745f6304fecd89.jpg?v=1754401804?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/ba2fcb3ef5319933097514453b25e795.jpg?v=1754401804?width=900",
    desc: "Somehow compassion became a partisan issue, and we're not having it. For the advocates, the volunteers, the loudest voices for the most vulnerable \u2014 and anyone who refuses to call basic human decency a 'hot take.' Soft unisex fit, pre-shrunk, runs true to size. Empathy isn't...",
    badge: "NEW",
  },
  {
    id: "deport-deez-nutz-unisex-tee-rebels-rights",
    name: "Deport Deez Nutz",
    type: "Unisex Tee",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "funny-and-political",
    slogan: "Deport Deez Nutz",
    price: 21.95,
    sizes: ["XS", "S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Dark Grey", "Heather Navy", "Dark Grey Heather", "Sage"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/35cea5fdba0124fd8184f5c2e997fe6f.jpg?v=1754401792?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/8179917d68c9a40d31a1eff23f48ca55.jpg?v=1754401792?width=900",
    desc: "When the policies are that absurd, the response gets to match. Immigration fear-mongering deserves exactly this level of respect \u2014 which is to say, none. For the satirists, the smartasses, and the activists who know that laughter is also a weapon. Soft unisex fit, pre-shrunk,...",
    badge: "NEW",
  },
  {
    id: "girls-just-want-to-have-fundamental-rights-women-s-tee-rebels-rights",
    name: "Girls Just Want to Have Fundamental Rights",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "Girls Just Want to Have Fundamental Rights",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Black", "Dark Grey Heather"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/7e75c70864ff53dcea58f136ec60bb85.jpg?v=1754401782?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/d315cd782406e7fcfd21b1f54f7b6519.jpg?v=1754401783?width=900",
    desc: "We updated Cyndi's agenda slightly: the right to vote, to bodily autonomy, to equal pay, and to not be talked over in meetings. Wild requests, apparently. Soft, fitted Bella+Canvas 6004, runs true to size. Not asking \u2014 demanding.",
    badge: "NEW",
  },
  {
    id: "my-body-my-business-women-s-tee-rebels-rights",
    name: "My Body My Business",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "My Body My Business",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Black", "Dark Grey Heather", "Heather Mauve", "Heather Blue Lagoon"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/0c67de4323fbdb91858029fccf484ef8.jpg?v=1754401773?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/04cf228530bb174e95bc771e49d96ce7.jpg?v=1754401772?width=900",
    desc: "Not a negotiation. Not a political platform. Not up for a vote. Your body belongs to you \u2014 full stop \u2014 and this shirt says so without apology. Soft, fitted Bella+Canvas 6004, runs true to size. Wear it loud, wear it proud.",
    badge: "NEW",
  },
  {
    id: "my-favorite-season-is-fall-of-the-patriarchy-women-s-tee-rebels-rights",
    name: "My Favorite Season Is Fall of the Patriarchy",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "My Favorite Season Is Fall of the Patriarchy",
    price: 24.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Heather Prism Natural", "Citron", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/0ddeaba1a6f3e1e41455c8587d87b462.jpg?v=1754401761?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/02596857d87f04ff18522f95d591ed48.jpg?v=1754401761?width=900",
    desc: "No pumpkin spice involved \u2014 just the crisp, refreshing feeling of watching old power structures crumble. For women who plan their activism around the calendar and their wardrobes around their values. Soft, fitted Bella+Canvas 6004, runs true to size. It's always the right season.",
    badge: "NEW",
  },
  {
    id: "no-kings-unisex-tee-rebels-rights",
    name: "No Kings",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "No Kings",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Dark Grey", "Heather Midnight Navy", "Heather Deep Teal", "Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/a044641bed063c48d967862b91db7805.jpg?v=1754401751?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/2d7d84957f44f5120d4688ce3e8bce49.jpg?v=1754401750?width=900",
    desc: "Two words. Centuries of meaning. From Magna Carta to the present moment, the fight against unchecked power never really ends \u2014 it just changes costumes. For the constitutionalists, the democracy defenders, and anyone who knows what it looks like when one person grabs too much....",
    badge: "NEW",
  },
  {
    id: "prejudice-is-an-emotional-commitment-to-ignorance-unisex-tee-rebels-rights",
    name: "Prejudice Is an Emotional Commitment to Ignorance",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Prejudice Is an Emotional Commitment to Ignorance",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Dark Grey", "Heather Navy", "Heather Deep Teal", "Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/a5b162506e6888e66c1cbb50595a224e.jpg?v=1754401740?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/0a009ba727ecb48e426c42d07112b034.jpg?v=1754401740?width=900",
    desc: "Call it what it is: a choice to stay wrong. This tee doesn't argue \u2014 it diagnoses. For the critical thinkers, the educators, and everyone who's watched hate get dressed up as tradition one too many times. Soft unisex fit, pre-shrunk, runs true to size. Let the shirt do the...",
    badge: "NEW",
  },
  {
    id: "nasty-but-classy-women-s-tee-rebels-rights",
    name: "Nasty but Classy",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "Nasty but Classy",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Dark Grey Heather", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/7daead250b5561f2fbc43d529a99a1ce.jpg?v=1754401730?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/c00b758e35c1b0b64425f42802449a15.jpg?v=1754401730?width=900",
    desc: "You reclaimed the insult, polished it up, and made it yours. This is for the women who are too much for some people and exactly enough for the right ones. Soft, fitted Bella+Canvas 6004, runs true to size. Own it.",
    badge: "NEW",
  },
  {
    id: "keep-your-politics-out-of-my-uterus-women-s-tee-rebels-rights",
    name: "Keep Your Politics Out of My Uterus",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "Keep Your Politics Out of My Uterus",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Black", "Dark Grey Heather"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/639855fbd4f9f904c3c8abfbc405fc95.jpg?v=1754401721?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/b848c9181be4f4fb2db1646d6f0bdac8.jpg?v=1754401721?width=900",
    desc: "Uninvited opinions about women's bodies have been unwelcome since forever \u2014 this shirt just makes the policy official. For the days you're done explaining medical autonomy to people in suits who've never needed an OB-GYN. Soft, fitted Bella+Canvas 6004, runs true to size. The...",
    badge: "NEW",
  },
  {
    id: "feminism-is-my-second-favorite-f-word-women-s-tee-rebels-rights",
    name: "Feminism Is My Second Favorite F-Word",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "Feminism Is My Second Favorite F-Word",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Black", "Dark Grey Heather"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/99805111d3bbc808175b6d110b7a36de.jpg?v=1754401711?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/d2a4a350b94a6ea0831c7319dfe76f00.jpg?v=1754401711?width=900",
    desc: "Bold enough to say it, clever enough to make you guess what the first one is. For women who bring both fire and wit to the fight \u2014 and aren't sorry about either. Soft, fitted Bella+Canvas 6004, runs true to size. Both F-words earned.",
    badge: "NEW",
  },
  {
    id: "sounds-gay-i-m-in-unisex-tee-rebels-rights",
    name: "Sounds Gay, I\u2019m In",
    type: "Unisex Tee",
    cause: "LGBTQ+",
    causeColor: "#7B4EA4",
    collection: "lgbtq-pride",
    slogan: "Sounds Gay, I\u2019m In",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Athletic Heather", "Yellow", "Heather Dust", "Heather Prism Ice Blue", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/028eee329065967ba6c90a9a438f7551.jpg?v=1754401701?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/bb1e477cb73dee9c05524dd187abb788.jpg?v=1754401701?width=900",
    desc: "Enthusiastic consent. Every time. This pride staple is for the joyfully queer, the loudly allied, and anyone who says yes first and asks questions later \u2014 especially if glitter is involved. Wear it to Pride, to brunch, to literally anywhere you want to radiate pure celebratory...",
    badge: "NEW",
  },
  {
    id: "veto-the-cheetoh-unisex-tee-rebels-rights",
    name: "Veto the Cheetoh",
    type: "Unisex Tee",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "funny-and-political",
    slogan: "Veto the Cheetoh",
    price: 21.95,
    sizes: ["XS", "S", "M", "L", "XL", "2X", "3X", "4X"],
    colors: ["Black Heather", "Navy", "Heather Midnight Navy", "Dark Grey Heather", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/b1922402dd6235b8c9373458651f6754.jpg?v=1754401690?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/65b66f1045511168eb104003cd337535.jpg?v=1754401690?width=900",
    desc: "Because sometimes the most serious thing you can do is laugh \u2014 loudly, in public, on a shirt. Political absurdity deserves absurdist commentary, and this one delivers. For the satirists, the sign-makers, and everyone who believes ridicule is a valid form of resistance. Soft...",
    badge: "NEW",
  },
  {
    id: "we-are-the-daughters-of-the-witches-you-couldn-t-burn-women-s-tee-rebels-rights",
    name: "We Are the Daughters of the Witches You Couldn\u2019t Burn",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "We Are the Daughters of the Witches You Couldn\u2019t Burn",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Black", "Dark Grey Heather", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/29ba106fe33f62a459b1027c4e597c42.jpg?v=1754401680?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/06dacb702699f7d0a34ee5e4f6c5c6ed.jpg?v=1754401681?width=900",
    desc: "They tried to silence women who were too smart, too powerful, too free \u2014 and here we still are, louder than ever. This one's for every woman who carries the fire they couldn't extinguish. Soft, fitted Bella+Canvas 6004, runs true to size. The line is unbroken.",
    badge: "NEW",
  },
  {
    id: "well-behaved-women-rarely-make-history-women-s-tee-rebels-rights",
    name: "Well-Behaved Women Rarely Make History",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "Well-Behaved Women Rarely Make History",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Black", "Dark Grey Heather"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/5b3c5a222ec4378a2f25607879e8b764.jpg?v=1754401672?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/f499ff05380309fdf4f19bf338eb9e81.jpg?v=1754401672?width=900",
    desc: "Every woman who changed the world had someone tell her to sit down and be quiet first. She didn't. This is for the rule-breakers, the loud ones, the ones who get called difficult and take it as a compliment. Soft, fitted Bella+Canvas 6004, runs true to size. Wear it like you...",
    badge: "NEW",
  },
  {
    id: "we-re-not-ovary-acting-women-s-tee-rebels-rights",
    name: "We\u2019re Not Ovary-Acting",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "We\u2019re Not Ovary-Acting",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Dark Grey Heather", "Heather Prism Natural", "Citron", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/c7cd1bc74331ecaabc0fb5b3b263c8f8.jpg?v=1754401662?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/ed76a1879f24ab1fe837234602b61396.jpg?v=1754401662?width=900",
    desc: "Your reproductive rights are not a debate topic \u2014 and you're done pretending otherwise. Wear this when you're fired up, showing up, and completely done explaining yourself to people who don't have a uterus. The Bella+Canvas 6004 gives you a soft, fitted cut that runs true to...",
    badge: "NEW",
  },
  {
    id: "she-who-writes-the-rules-wins-women-s-tee-rebels-rights",
    name: "She Who Writes the Rules Wins",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "She Who Writes the Rules Wins",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Dark Grey Heather", "Berry", "Heather Mauve", "Leaf"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/8ea49bd9aefb3db004bb53a57c1a45a2.jpg?v=1754401652?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/0b22ff19998419173e3eda7fe76e3516.jpg?v=1754401652?width=900",
    desc: "The rules were written without us in the room \u2014 time to rewrite them. For the organizers, the candidates, the CEOs, the women reshaping every system that was never built for them. Soft, fitted Bella+Canvas 6004, runs true to size. Stop playing the game. Change it.",
    badge: "NEW",
  },
  {
    id: "rise-above-hate-unisex-tee-rebels-rights",
    name: "Rise Above Hate",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Rise Above Hate",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Athletic Heather", "Heather Dust", "Heather Prism Ice Blue", "Ash", "Vintage White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/6a02817a06cc74affc974d1670b27576.jpg?v=1754401641?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/037972d13e1cca9dbd23b280513617b8.jpg?v=1754401641?width=900",
    desc: "Not naively \u2014 fiercely. Rising above hate isn't passive; it's a choice made daily in the face of everything designed to drag you down. For the coalition builders, the bridge-crossers, and the ones who won't let the ugliest forces in the room define the room. Soft unisex fit,...",
    badge: "NEW",
  },
  {
    id: "eat-the-rich-unisex-tee-rebels-rights",
    name: "Eat the Rich",
    type: "Unisex Tee",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "funny-and-political",
    slogan: "Eat the Rich",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Dark Grey", "Heather Navy", "Steel Blue", "Sage", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/774013cd607f2583088e27b6d7aaa98d.jpg?v=1754401631?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/5493ef9fe1883c7d09b010fd476ed776.jpg?v=1754401631?width=900",
    desc: "When three people own more than the bottom half of the planet combined, something's gone very wrong \u2014 and polite conversation isn't fixing it. For the economic justice fighters, the union members, and everyone who's working two jobs and still behind. Soft unisex fit, pre-shrunk,...",
    badge: "NEW",
  },
  {
    id: "patriarchy-s-worst-nightmare-women-s-tee-rebels-rights",
    name: "Patriarchy\u2019s Worst Nightmare",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "Patriarchy\u2019s Worst Nightmare",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Black", "Dark Grey Heather", "Heather Mauve", "Leaf"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/8f779070880cc5c5b659ca0cae35e1d9.jpg?v=1754401622?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/29cc54c63720faf2d3d3390bfd26e42c.jpg?v=1754401622?width=900",
    desc: "Educated, organized, and completely out of patience \u2014 that's you, and the whole system knows it. Wear this to the march, the meeting, the poll booth, or just the grocery store. Soft, fitted Bella+Canvas 6004, runs true to size. You don't need their permission.",
    badge: "NEW",
  },
  {
    id: "educate-agitate-organize-unisex-tee-rebels-rights",
    name: "Educate, Agitate, Organize",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Educate, Agitate, Organize",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Heather Prism Dusty Blue", "Athletic Heather", "Soft Pink", "Ash", "Vintage White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/4c046f3d650b8a2f6d3ae1c9686d5612.jpg?v=1754401611?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/5f590c0a079c3fb2654775ebb2ebdca2.jpg?v=1754401612?width=900",
    desc: "The three-step playbook that built every workers' right you have \u2014 and the one you'll need to keep them. From the labor halls of the 1800s to the picket lines of today, this slogan has aged into a mandate. For the organizers, the agitators, and the ones doing the quiet work that...",
    badge: "NEW",
  },
  {
    id: "it-s-okay-to-feel-all-the-feels-unisex-tee-rebels-rights",
    name: "It\u2019s Okay to Feel All the Feels",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "It\u2019s Okay to Feel All the Feels",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Dark Grey", "Heather Navy", "Asphalt", "Army"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/9eabda18a2b408ef6282d4d424d2be1e.jpg?v=1754401601?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/b3a7fcbd2156b93db52737a657f801a7.jpg?v=1754401601?width=900",
    desc: "Joy, grief, rage, tenderness \u2014 sometimes all before noon. This tee holds space for the full spectrum of being human, no apology required. For the emotionally fluent, the beautifully messy, and everyone still figuring it out. Bella+Canvas 3001 soft unisex fit, pre-shrunk, runs...",
    badge: "NEW",
  },
  {
    id: "it-s-okay-to-feel-your-feelings-unisex-tee-rebels-rights",
    name: "It\u2019s Okay to Feel Your Feelings",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "It\u2019s Okay to Feel Your Feelings",
    price: 21.95,
    sizes: ["XS", "S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Cardinal", "Dark Grey", "Heather Navy", "Military Green"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/3994211008d722781f34ca8760e7471f.jpg?v=1754401591?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/4eed3d61d3791cf0f42690fb1e1fd03b.jpg?v=1754401591?width=900",
    desc: "Radical softness as a political act. This tee is a gentle reminder \u2014 for yourself or someone who needs to hear it \u2014 that feelings aren't a flaw, they're information. Wear it to the protest, the therapy waiting room, or just a Tuesday. Bella+Canvas 3001 soft unisex fit,...",
    badge: "NEW",
  },
  {
    id: "more-rage-less-beige-unisex-tee-rebels-rights",
    name: "More Rage. Less Beige.",
    type: "Unisex Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "feminist",
    slogan: "More Rage. Less Beige.",
    price: 21.95,
    sizes: ["XS", "S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Dark Grey", "Heather Navy", "Military Green", "Heather Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/84601c89d7dbf5d4769d4e770ff8102f.jpg?v=1754401581?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/2e74525509e6aa1a52dfac07e7dca7fb.jpg?v=1754401581?width=900",
    desc: "Beige is inoffensive by design \u2014 and this world has enough of that. Stop softening your edges for the comfort of people who benefit from your silence. For the loud, the unpolished, and everyone who decided that staying palatable is its own kind of surrender. Soft unisex fit,...",
    badge: "NEW",
  },
  {
    id: "nevertheless-she-persisted-women-s-tee-rebels-rights",
    name: "Nevertheless, She Persisted",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "Nevertheless, She Persisted",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Black", "Dark Grey Heather"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/89c12d58abef429def8d6bf277b22ddf.jpg?v=1754401571?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/38c36a549fb9e7de27b836f9205b07e3.jpg?v=1754401571?width=900",
    desc: "They silenced her on the Senate floor and handed the resistance its rallying cry. This phrase belongs to every woman who was told to stop and kept going anyway \u2014 in courtrooms, classrooms, and boardrooms. Soft, fitted Bella+Canvas 6004, runs true to size. She always persists.",
    badge: "NEW",
  },
  {
    id: "rights-not-wrongs-unisex-tee-rebels-rights",
    name: "Rights Not Wrongs",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Rights Not Wrongs",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Heather Navy", "Dark Grey Heather", "Heather Slate", "Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/f135d9d1286cd5ae7e89b5d9df3ae031.jpg?v=1754401561?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/e07be9ec9dcbdcbd11d9a0ff47005b2b.jpg?v=1754401561?width=900",
    desc: "Civil rights aren't a debate topic \u2014 they're a baseline. This one's for the organizers, the advocates, and everyone who's tired of explaining why basic dignity shouldn't require a fight. Simple message. Non-negotiable meaning. Soft unisex fit, pre-shrunk, runs true to size. Show...",
    badge: "NEW",
  },
  {
    id: "my-therapist-knows-about-you-unisex-tee-rebels-rights",
    name: "My Therapist Knows About You",
    type: "Unisex Tee",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "funny-and-political",
    slogan: "My Therapist Knows About You",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X", "4X"],
    colors: ["Black Heather", "Heather Navy", "Dark Grey Heather", "Heather Deep Teal", "Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/976fcc505744802803c6aa4c210ff3cf.jpg?v=1754401550?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/32f5064ba545e06378b29ca0439c58b1.jpg?v=1754401550?width=900",
    desc: "You've been discussed at length \u2014 and honestly, you earned it. This one's for everyone doing the work: processing, unpacking, and occasionally venting to a professional about That Person. Soft unisex fit, pre-shrunk, runs true to size on the Bella+Canvas 3001. Wear it proudly....",
    badge: "NEW",
  },
  {
    id: "my-dog-and-i-talk-shit-about-you-unisex-tee-rebels-rights",
    name: "My Dog and I Talk Shit About You",
    type: "Unisex Tee",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "funny-and-political",
    slogan: "My Dog and I Talk Shit About You",
    price: 21.95,
    sizes: ["XS", "S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Heather Navy", "Dark Grey Heather", "Heather Slate", "Heather Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/42be3d17df114fe3c3cb085bd5555e58.jpg?v=1754401539?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/edfa40e7d1a16b4d155c4036d5cdc6bd.jpg?v=1754401539?width=900",
    desc: "The jury has deliberated. The verdict is unanimous. You and your most loyal confidant are fully aligned on this one. For everyone who debriefs with their dog after a rough day \u2014 because honestly, they get it. Bella+Canvas 3001 soft unisex fit, pre-shrunk, runs true to size. No...",
    badge: "NEW",
  },
  {
    id: "fox-news-is-elder-abuse-unisex-tee-rebels-rights",
    name: "Fox News Is Elder Abuse",
    type: "Unisex Tee",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "funny-and-political",
    slogan: "Fox News Is Elder Abuse",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Heather Navy", "Dark Grey Heather", "Heather Forest", "Heather Slate"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/e5799f4b4c85f485b52051463b8f15a2.jpg?v=1754401528?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/7e04ba1f4f027e938b2007c8611a49d2.jpg?v=1754401528?width=900",
    desc: "Outrage programming designed for vulnerable audiences isn't journalism \u2014 it's exploitation. This tee says the quiet part loud, for the media critics, the frustrated adult children, and everyone who's watched a relative get radicalized by the remote. Soft unisex fit, pre-shrunk,...",
    badge: "NEW",
  },
  {
    id: "black-lives-matter-unisex-tee-rebels-rights",
    name: "Black Lives Matter",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Black Lives Matter",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X", "4X"],
    colors: ["Black Heather", "Heather Navy", "Dark Grey Heather", "Heather Deep Teal", "Heather Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/f35940a2241e33aed550c807c9917aca.jpg?v=1754401518?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/1e4ff67c249db5481a96e71682975906.jpg?v=1754401518?width=900",
    desc: "Not a slogan. A statement of fact that shouldn't require repeating \u2014 and yet. For the marchers, the mourners, the educators, and everyone who refuses to let the urgency fade between news cycles. This one doesn't negotiate. It affirms. Soft unisex fit, pre-shrunk, runs true to...",
    badge: "NEW",
  },
  {
    id: "a-woman-s-place-is-in-the-house-and-the-senate-women-s-tee-rebels-rights",
    name: "A Woman\u2019s Place Is in the House and the Senate",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "A Woman\u2019s Place Is in the House and the Senate",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Black", "Dark Grey Heather"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/3ecb53caab002b618a833ed963de64b7.jpg?v=1754401508?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/d6b888a4cdd54eaec2420860abb4ecaf.jpg?v=1754401509?width=900",
    desc: "Still your mind. Or at least your feed. This minimalist wellness graphic is for the meditators, the seekers, and the people who downloaded the app and are genuinely trying. Wear it to yoga, to the farmers market, to wherever you go to feel like yourself again. Bella+Canvas 3001...",
    badge: "NEW",
  },
  {
    id: "currently-overthinking-about-overthinking-unisex-tee-rebels-rights",
    name: "Currently Overthinking About Overthinking",
    type: "Unisex Tee",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "funny-and-political",
    slogan: "Currently Overthinking About Overthinking",
    price: 21.95,
    sizes: ["XS", "S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Heather Midnight Navy", "Heather Slate", "Heather Mauve", "Sage"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/0f9a6684ccb273113486c8f1727e6f01.jpg?v=1754401498?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/d899594e90b1b5cc482173b4a3648fa1.jpg?v=1754401496?width=900",
    desc: "The recursion is the point. You're not just an overthinker \u2014 you're a meta-overthinker, and that deserves recognition. This tee is peak self-aware chaos energy, and the people who get it will really get it. Bella+Canvas 3001 soft unisex fit, pre-shrunk, runs true to size. Add to...",
    badge: "NEW",
  },
  {
    id: "fries-before-guys-women-s-tee-rebels-rights",
    name: "Fries Before Guys",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "Fries Before Guys",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Black", "Dark Grey Heather", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/f05685d2943ea9f96e73d953f7028559.jpg?v=1754401486?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/a5729986cf0b30667d6e94f1256ff913.jpg?v=1754401486?width=900",
    desc: "A love story about choosing yourself, your friends, and crispy golden fries over situationships that drain your energy. Light-hearted, unapologetic, and a little chaotic \u2014 exactly right. Soft, fitted Bella+Canvas 6004, runs true to size. Priorities sorted.",
    badge: "NEW",
  },
  {
    id: "fueled-by-feminism-and-iced-coffee-women-s-tee-rebels-rights",
    name: "Fueled by Feminism and Iced Coffee",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "Fueled by Feminism and Iced Coffee",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Black", "Dark Grey Heather", "Heather Mauve", "Heather Blue Lagoon"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/6a3907c339d987914bd7e27f3d891e81.jpg?v=1754401477?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/c1fd3323a7c33104dfe2357927f8998f.jpg?v=1754401477?width=900",
    desc: "Two things that keep you going: the relentless pursuit of equality and a large iced coffee, extra oat milk. For the woman who can dissect systemic oppression and still make a 9am meeting. Soft, fitted Bella+Canvas 6004, runs true to size. The movement runs on caffeine.",
    badge: "NEW",
  },
  {
    id: "hi-i-m-in-therapy-unisex-tee-rebels-rights",
    name: "Hi, I\u2019m in Therapy\u201d Unisex Tee",
    type: "Unisex Tee",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "funny-and-political",
    slogan: "Hi, I\u2019m in Therapy\u201d Unisex Tee",
    price: 21.95,
    sizes: ["XS", "S", "M", "L", "XL", "2X"],
    colors: ["Sage", "Heather Prism Lilac", "Heather Prism Dusty Blue", "Athletic Heather", "Vintage White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/c242b4a3dceef1d6333e9bbb3ee18522.jpg?v=1754401467?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/4285d20dd5efc275ebd434ac031eb2f0.jpg?v=1754401467?width=900",
    desc: "This t-shirt is everything you've dreamed of and more. It feels soft and lightweight, with the right amount of stretch. It's comfortable and flattering for all. \u2022 100% combed and ring-spun cotton (Heather colors contain polyester) \u2022 Fabric weight: 4.2 oz./yd.\u00b2 (142 g/m\u00b2) \u2022...",
    badge: "NEW",
  },
  {
    id: "i-overthink-on-purpose-unisex-tee-rebels-rights",
    name: "I Overthink On Purpose",
    type: "Unisex Tee",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "funny-and-political",
    slogan: "I Overthink On Purpose",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X", "4X"],
    colors: ["Black Heather", "Heather Navy", "Dark Grey Heather", "Army", "Heather Deep Teal"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/b3d6465ac31bf4ded202bcedaa87f245.jpg?v=1754401457?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/ff4c49df97657183385c9911c9d85d91.jpg?v=1754401459?width=900",
    desc: "Not a bug. Not a disorder. A lifestyle. While everyone else is acting impulsively, you've already considered seventeen outcomes and drafted a contingency plan. This one's for the deliberate thinkers, the what-if-ers, the people who are actually just very thorough. Bella+Canvas...",
    badge: "NEW",
  },
  {
    id: "if-only-men-were-as-reliable-as-birth-control-women-s-tee-rebels-rights",
    name: "If Only Men Were As Reliable As Birth Control",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "If Only Men Were As Reliable As Birth Control",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Black", "Dark Grey Heather", "Citron"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/27fbfb2d91f9881294cd2d1dc51fceab.jpg?v=1754401448?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/70894643464c1b63c132cf819182dfb6.jpg?v=1754401448?width=900",
    desc: "Over 99% effective. Never cancels plans. Doesn't need to be asked twice. The bar is on the floor and your contraception cleared it easily. For the group chat, the girls' trip, and every woman who's done the math. Soft, fitted Bella+Canvas 6004, runs true to size.",
    badge: "NEW",
  },
  {
    id: "this-is-america-unisex-tee-rebels-rights",
    name: "This is America?",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "This is America?",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X", "4X"],
    colors: ["Black Heather", "Heather Navy", "Heather Forest", "Heather Mauve", "Steel Blue"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/fba9bf2810de26c98b5ab4821de20eca.jpg?v=1754401438?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/d4748bf609bc220b34cb423f565dfc86.jpg?v=1754401438?width=900",
    desc: "The question mark does all the work. For everyone watching the gap between the promise and the reality grow wider by the day \u2014 and refusing to pretend that's normal. Wear it to the march, the meeting, the mundane Tuesday that suddenly doesn't feel so mundane. Soft unisex fit,...",
    badge: "NEW",
  },
  {
    id: "i-39-m-speaking-to-my-plants-today-women-s-tee-rebels-rights",
    name: "I&#39;m Speaking To My Plants Today",
    type: "Women's Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "womens-tees",
    slogan: "I&#39;m Speaking To My Plants Today",
    price: 23.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Navy", "Dark Grey Heather", "Heather Red", "Heather Mauve", "Leaf"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/6903c6423da36cdbf3ccb465e6753b4a.jpg?v=1754401427?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/d1eddfdec8865b3081dacd1ef3cb4705.jpg?v=1754401427?width=900",
    desc: "Some days the plants get it. They listen, they don't interrupt, and they genuinely appreciate the attention. For the introverts, the overstimulated, and anyone who needs a firm boundary between themselves and the world today. Soft, fitted Bella+Canvas 6004, runs true to size....",
    badge: "NEW",
  },
  {
    id: "will-trade-racists-for-refugees-unisex-tee-rebels-rights",
    name: "Will Trade Racists for Refugees",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Will Trade Racists for Refugees",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Heather Navy", "Dark Grey Heather", "Heather Forest", "Heather Slate"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/unisex-staple-t-shirt-dark-grey-heather-front-68921cab8e80a.jpg?v=1754406075?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/unisex-staple-t-shirt-heather-forest-front-68921caba1e87.jpg?v=1754406075?width=900",
    desc: "A proposal that's as serious as it is satisfying. Refugees flee violence and build communities \u2014 we know this because we've seen it happen, generation after generation. For the pro-immigrant voices, the history-literate, and everyone who'd happily make that swap. Soft unisex...",
    badge: "NEW",
  },
  {
    id: "do-good-unisex-classic-tee-rebels-rights",
    name: "Do Good",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Do Good",
    price: 19.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Brown Savana", "Sport Grey", "Natural", "Ice Grey", "White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/ccb9a6fa80e079561033629c60cb7549.jpg?v=1754401407?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/7a1036f882a08d64bcd102e9d660fe27.jpg?v=1754401407?width=900",
    desc: "Not complicated. Not conditional. Just the most radical thing you can do in a world that keeps incentivizing the opposite. A daily reminder that activism doesn't always look like a march \u2014 sometimes it's a choice, a conversation, a habit. Heavyweight garment-dyed with a worn-in...",
    badge: "NEW",
  },
  {
    id: "it-s-giving-small-dicktator-energy-unisex-tee-rebels-rights",
    name: "It\u2019s Giving Small Dicktator Energy",
    type: "Unisex Tee",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "funny-and-political",
    slogan: "It\u2019s Giving Small Dicktator Energy",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Vintage Black", "Heather Navy", "Heather Forest", "Heather Slate", "Heather Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/d42c2e398467460b04259232f7f84d72.jpg?v=1754401397?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/fa6aef056c599c60f69f733bae0e3968.jpg?v=1754401397?width=900",
    desc: "The fragile ego. The overcompensation. The desperate need to dominate everything within arm's reach. We see you. For the culturally fluent, the politically sharp, and everyone who communicates in both protest signs and pop culture. This one hits different because it's accurate....",
    badge: "NEW",
  },
  {
    id: "fight-ignorance-not-immigrants-unisex-tee-rebels-rights",
    name: "Fight Ignorance, Not Immigrants",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Fight Ignorance, Not Immigrants",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Heather Prism Dusty Blue", "Athletic Heather", "Heather Dust", "Vintage White", "Citron"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/ec17a62d86a1862bb628b3e99533a4b1.jpg?v=1754401387?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/eed2717ff2827b2401ac7c0b7e29a086.jpg?v=1754401387?width=900",
    desc: "The real threat to this country has never shown up in a caravan. For the immigration justice advocates, the children of immigrants, and everyone who's read even one page of actual history. This country was built by people who weren't from here \u2014 full stop. Soft unisex fit,...",
    badge: "NEW",
  },
  {
    id: "history-has-its-eyes-on-you-unisex-tee-rebels-rights",
    name: "History Has Its Eyes on You",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "History Has Its Eyes on You",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Black Heather", "Heather Navy", "Heather Forest", "Heather Deep Teal", "Heather Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/df6db888d6233fe7925ef550a7bf31a7.jpg?v=1754401374?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/980ac7d0d65afca2340ca0bc9e86a3d2.jpg?v=1754401374?width=900",
    desc: "Hamilton said it. The moment said it. And right now, history is watching every politician, every bystander, every one of us choose a side. For the accountability-holders and the legacy-conscious \u2014 the ones who think about how this chapter gets written. Soft unisex fit,...",
    badge: "NEW",
  },
  {
    id: "only-butterflies-should-be-monarchs-unisex-tee-rebels-rights",
    name: "Only Butterflies Should Be Monarchs",
    type: "Unisex Tee",
    cause: "Humor",
    causeColor: "#C68415",
    collection: "funny-and-political",
    slogan: "Only Butterflies Should Be Monarchs",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Heather Dust", "Heather Prism Ice Blue", "Silver", "Vintage White", "Citron"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/e2f0420e91a24853d94f5d45c2552eb6.jpg?v=1754401365?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/925505a69273f250c63d74f5c6045b2f.jpg?v=1754401365?width=900",
    desc: "Democracy isn't a gift from the aristocracy \u2014 it's something people fought and died to build. This one's for the republicans (lowercase r), the anti-royalists, and everyone who thinks inherited power belongs in fairy tales. Soft unisex fit, pre-shrunk, runs true to size. Crown...",
    badge: "NEW",
  },
  {
    id: "no-kings-yaaasss-queens-unisex-tee-rebels-rights",
    name: "No Kings Yaaasss Queens",
    type: "Unisex Tee",
    cause: "LGBTQ+",
    causeColor: "#7B4EA4",
    collection: "lgbtq-pride",
    slogan: "No Kings Yaaasss Queens",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X", "4X"],
    colors: ["Black Heather", "Team Purple", "Maroon", "Heather Navy", "Heather Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/3496b4403c0aa7542bd81e08d05d9d7e.jpg?v=1754401354?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/316168f9d56ad699a7ab65284aba947e.jpg?v=1754401354?width=900",
    desc: "Abolish the throne, celebrate the community. Democracy is for everyone \u2014 and so is a little fabulousness. This one sits at the intersection of political fire and queer joy, because the LGBTQ+ community has always known how to fight with style. Soft unisex fit, pre-shrunk, runs...",
    badge: "NEW",
  },
  {
    id: "when-tyranny-becomes-law-rebellion-becomes-duty-unisex-tee-rebels-rights",
    name: "When\u00a0Tyranny\u00a0Becomes\u00a0Law,\u00a0Rebellion\u00a0Becomes\u00a0Duty",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "When\u00a0Tyranny\u00a0Becomes\u00a0Law,\u00a0Rebellion\u00a0Becomes\u00a0Duty",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Black Heather", "Heather Navy", "Dark Grey Heather", "Heather Olive", "Heather Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/bdabd6546e11028ad02a687ab7cf070b.jpg?v=1754401343?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/4a2ab679e20fb79366387c7923bde3c8.jpg?v=1754401344?width=900",
    desc: "Some quotes don't age \u2014 they activate. When the rules serve the rulers and not the people, resistance isn't just justified, it's required. For the history-readers, the street-walkers, the ones who know exactly how we got here and refuse to go quietly. Soft unisex fit,...",
    badge: "NEW",
  },
  {
    id: "om-unisex-tee-rebels-rights",
    name: "OM",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "OM",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Black Heather", "Heather Navy", "Dark Grey Heather", "Heather Mauve", "Pebble"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/8d65a7b9d04015044cc02d254806fb1a.jpg?v=1754401332?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/19e4480447233ab511a59cb7a45dfc76.jpg?v=1754401332?width=900",
    desc: "Still your mind. Or at least your feed. This minimalist wellness graphic is for the meditators, the seekers, and the people who downloaded the app and are genuinely trying. Wear it to yoga, to the farmers market, to wherever you go to feel like yourself again. Bella+Canvas 3001...",
    badge: "NEW",
  },
  {
    id: "caring-about-other-people-is-not-political-unisex-tee-rebels-rights",
    name: "Caring About Other People Is Not Political",
    type: "Unisex Tee",
    cause: "Feminist",
    causeColor: "#B83280",
    collection: "feminist",
    slogan: "Caring About Other People Is Not Political",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Heather Midnight Navy", "Dark Grey Heather", "Athletic Heather", "Vintage White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/72eb1b36aaa96a155f749c9cdac2af40.jpg?v=1754401322?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/434f9b842c1475c4273bbab69238d786.jpg?v=1754401322?width=900",
    desc: "Somehow compassion became a partisan issue, and we're not having it. For the advocates, the volunteers, the loudest voices for the most vulnerable \u2014 and anyone who refuses to call basic human decency a 'hot take.' Soft unisex fit, pre-shrunk, runs true to size. Empathy isn't...",
    badge: "NEW",
  },
  {
    id: "habeas-corpus-sugar-skull-tee-rebels-rights",
    name: "Habeas Corpus",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Habeas Corpus",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Black Heather", "Heather Midnight Navy", "Dark Grey Heather", "Heather Deep Teal", "Heather Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/19ff70a5c7ce02cb5cbad7ee6ab55e27.jpg?v=1754401312?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/95abdd2120877a7c6cf6a054d3172a8c.jpg?v=1754401311?width=900",
    desc: "The right to your own body, your own freedom, your own day in court \u2014 honored in death-defying style. This sugar skull design fuses constitutional bedrock with D\u00eda de los Muertos iconography, because some rights are worth dying for. For the legal warriors and the culturally...",
    badge: "NEW",
  },
  {
    id: "habeas-corpus-color-sugar-skull-tee-rebels-rights",
    name: "Habeas Corpus (color)",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Habeas Corpus (color)",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X"],
    colors: ["Black Heather", "Oxblood Black", "Heather Midnight Navy", "Heather Prism Lilac", "Vintage White"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/08b5c4ce1e1a5643491db9ae8f97eebb.jpg?v=1754401301?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/0542553cd913dd98eb6fd35f00b9404e.jpg?v=1754401301?width=900",
    desc: "Same unbreakable principle, now in full color \u2014 because the fight for due process should be impossible to ignore. The constitutional right that separates free societies from authoritarian ones, rendered in bold, unapologetic design. For the lawyers, the activists, and the...",
    badge: "NEW",
  },
  {
    id: "liberty-and-justice-for-all-unisex-tee-rebels-rights",
    name: "Liberty and Justice for ALL",
    type: "Unisex Tee",
    cause: "Protest",
    causeColor: "#B82A2A",
    collection: "protest",
    slogan: "Liberty and Justice for ALL",
    price: 21.95,
    sizes: ["S", "M", "L", "XL", "2X", "3X"],
    colors: ["Black Heather", "Heather Midnight Navy", "Military Green", "Heather Deep Teal", "Heather Mauve"],
    img: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/d11be3db64e14062085c4e70bcf77258.jpg?v=1754401290?width=900",
    imgAlt: "https://cdn.shopify.com/s/files/1/0757/4362/5453/files/3c67f06fcc41b0e3b5a2469c8ff09025.jpg?v=1754401291?width=900",
    desc: "You've been reciting it since kindergarten. Now mean it. That last word \u2014 ALL \u2014 is the whole fight, and it always has been. For the civil rights advocates, the coalition builders, and everyone who refuses to let the pledge be performative. Soft unisex fit, pre-shrunk, runs true...",
    badge: "NEW",
  }
];

// ============================================================================
// Editorial data — issues, events, dispatch, cause percentages.
// ============================================================================
var ISSUES = [
  {id:"01",tag:"Reproductive Rights",shopId:"feminist",headline:"The Fight for Bodily Autonomy Isn\u2019t Over",body:"Since Dobbs, 14 states have near-total bans. Clinics have closed. People are crossing state lines for basic healthcare. This is the front line.",org:"Planned Parenthood Action Fund",orgUrl:"https://www.plannedparenthoodaction.org/"},
  {id:"02",tag:"LGBTQ+ Rights",shopId:"lgbtq-pride",headline:"400+ Anti-Trans Bills in One Legislative Session",body:"Bills targeting trans youth in sports, bathrooms, and healthcare have exploded across state legislatures. The policy is the point\u2014the harm is the goal.",org:"ACLU LGBTQ+ Rights Project",orgUrl:"https://www.aclu.org/lgbtq-rights"},
  {id:"03",tag:"Voting Rights",shopId:"protest",headline:"Voter Suppression Is Getting More Sophisticated",body:"Gerrymandering, ID laws, polling-place closures in minority communities\u2014each tactic is designed to make your vote count less. Know the playbook.",org:"Brennan Center for Justice",orgUrl:"https://www.brennancenter.org/"},
  {id:"04",tag:"Immigration",shopId:"protest",headline:"Due Process Is Not Optional",body:"Expedited deportations, family separations, and the erosion of asylum protections are rewriting what 'rule of law' means in practice.",org:"RAICES",orgUrl:"https://www.raicestexas.org/"}
];
var EVENTS = [];
var DISPATCH = [
  {id:"what-is-intersectionality-and-why-does-it-matter-for-organizing",tags:["feminism", "intersectionality"],title:"What Is Intersectionality \u2014 And Why Does It Matter for Organizing?",date:"May 2026",read:"4 min read"},
  {id:"the-youth-climate-strikes-are-growing-up-now-what",tags:["climate", "direct action"],title:"The Youth Climate Strikes Are Growing Up. Now What?",date:"May 2026",read:"4 min read"},
  {id:"how-to-talk-to-someone-who-disagrees-with-you-without-losing-your-mind",tags:["activism", "communication"],title:"How to Talk to Someone Who Disagrees With You (Without Losing Your Mind)",date:"May 2026",read:"3 min read"},
  {id:"the-new-abortion-landscape-what-changed-whats-left-to-fight",tags:["abortion", "dobbs"],title:"The New Abortion Landscape: What Changed, What's Left to Fight",date:"May 2026",read:"4 min read"},
  {id:"what-no-kings-actually-means-a-short-history-of-anti-authoritarian-resistance",tags:["anti-authoritarianism", "democracy"],title:"What 'No Kings' Actually Means: A Short History of Anti-Authoritarian Resistance",date:"May 2026",read:"3 min read"},
  {id:"the-history-of-dissent-from-suffragettes-to-standing-rock",tags:["history", "movements"],title:"The History of Dissent: From Suffragettes to Standing Rock",date:"May 2026",read:"5 min read"},
  {id:"10-organizations-worth-supporting-right-now",tags:["activism", "donate"],title:"10 Organizations Worth Supporting Right Now",date:"May 2026",read:"4 min read"},
  {id:"why-graphic-tees-are-a-form-of-political-speech",tags:["activism", "fashion"],title:"Why Graphic Tees Are a Form of Political Speech",date:"May 2026",read:"4 min read"}
];
var CAUSES_PCT = {feminist:32,"lgbtq-pride":18,protest:28,humor:14,wellness:8};
